const RELATORIOS_FILTERS_STORAGE_KEY = "relatoriosFilters";

export const EMPTY_CUSTOM_FILTER = {
  contrato: "",
  cnpj: "",
  lote: "",
  placa: "",
};

const DEFAULT_FILTER_STATE = {
  equipmentList: [],
  startDate: "",
  endDate: "",
  ultimoClicado: null,
  lastData: 29,
  filterData: "all",
  customFilter: { ...EMPTY_CUSTOM_FILTER },
  activeQuery: "default",
  searchValue: "",
  curvaSelecionada: "",
};

const isValidEquipmentMapping = (item) =>
  item &&
  typeof item === "object" &&
  String(item.companyId || "").trim() &&
  String(item.equipment || "").trim();

const sanitizeCustomFilter = (value) => ({
  contrato: String(value?.contrato || ""),
  cnpj: String(value?.cnpj || ""),
  lote: String(value?.lote || ""),
  placa: String(value?.placa || ""),
});

const sanitizeActiveQuery = (value) =>
  value === "period" || value === "date" || value === "default"
    ? value
    : "default";

/**
 * Mantém apenas mapeamentos que ainda existem nas unidades do usuário.
 */
export const sanitizeEquipmentList = (list = [], companies = []) => {
  if (!Array.isArray(list) || !list.length) return [];

  const validSerialsByCompany = new Map();
  (companies || []).forEach((company) => {
    const companyId = String(company?._id || "").trim();
    if (!companyId) return;
    validSerialsByCompany.set(
      companyId,
      new Set(
        (company.equipments || [])
          .map((serial) => String(serial || "").trim())
          .filter(Boolean)
      )
    );
  });

  return list.filter((item) => {
    if (!isValidEquipmentMapping(item)) return false;
    const companyId = String(item.companyId).trim();
    const serial = String(item.equipment).trim();
    const allowed = validSerialsByCompany.get(companyId);
    return Boolean(allowed?.has(serial));
  });
};

export const readStoredRelatoriosFilters = (companies = []) => {
  try {
    const raw = sessionStorage.getItem(RELATORIOS_FILTERS_STORAGE_KEY);
    if (!raw) return { ...DEFAULT_FILTER_STATE };

    const parsed = JSON.parse(raw);
    const equipmentList = sanitizeEquipmentList(
      Array.isArray(parsed?.equipmentList) ? parsed.equipmentList : [],
      companies
    );

    return {
      equipmentList,
      startDate: String(parsed?.startDate || ""),
      endDate: String(parsed?.endDate || ""),
      ultimoClicado:
        parsed?.ultimoClicado === null || parsed?.ultimoClicado === undefined
          ? null
          : Number(parsed.ultimoClicado),
      lastData:
        parsed?.lastData === null || parsed?.lastData === undefined
          ? 29
          : Number(parsed.lastData) || 29,
      filterData:
        parsed?.filterData === "input" || parsed?.filterData === "output"
          ? parsed.filterData
          : "all",
      customFilter: sanitizeCustomFilter(parsed?.customFilter),
      activeQuery: sanitizeActiveQuery(parsed?.activeQuery),
      searchValue: String(parsed?.searchValue || ""),
      curvaSelecionada: String(parsed?.curvaSelecionada || ""),
    };
  } catch {
    return { ...DEFAULT_FILTER_STATE };
  }
};

export const persistRelatoriosFilters = (state) => {
  try {
    const payload = {
      equipmentList: Array.isArray(state.equipmentList)
        ? state.equipmentList.filter(isValidEquipmentMapping)
        : [],
      startDate: String(state.startDate || ""),
      endDate: String(state.endDate || ""),
      ultimoClicado:
        state.ultimoClicado === null || state.ultimoClicado === undefined
          ? null
          : Number(state.ultimoClicado),
      lastData:
        state.lastData === null || state.lastData === undefined
          ? 29
          : Number(state.lastData) || 29,
      filterData:
        state.filterData === "input" || state.filterData === "output"
          ? state.filterData
          : "all",
      customFilter: sanitizeCustomFilter(state.customFilter),
      activeQuery: sanitizeActiveQuery(state.activeQuery),
      searchValue: String(state.searchValue || ""),
      curvaSelecionada: String(state.curvaSelecionada || ""),
    };

    sessionStorage.setItem(
      RELATORIOS_FILTERS_STORAGE_KEY,
      JSON.stringify(payload)
    );
  } catch {
    /* sessionStorage cheio ou indisponível */
  }
};

export const clearStoredRelatoriosFilters = () => {
  try {
    sessionStorage.removeItem(RELATORIOS_FILTERS_STORAGE_KEY);
  } catch {
    /* ignore */
  }
};
